import { create } from 'zustand';

import { Label, PanelMode } from 'src/apps/dashboard/pages/label-management/types';
import { mapPlatformLabels } from 'src/apps/dashboard/services/label-management';
import { usePlatformConfigStore } from 'src/common/stores/platformConfigStore';

interface LabelManagementState {
	labels: Label[];
	isSaving: boolean;
	isDeleting: boolean;
	isPanelOpen: boolean;
	panelMode: PanelMode;
	activeLabel: Label | null;
	labelToDelete: Label | null;

	saveLabel: () => Promise<void>;
	deleteLabel: () => Promise<void>;
	openAddPanel: () => void;
	openEditPanel: (label: Label) => void;
	closePanel: () => void;
	requestDelete: (label: Label) => void;
	cancelDelete: () => void;
	reset: () => void;
}

const initialState = {
	labels: [],
	isSaving: false,
	isDeleting: false,
	isPanelOpen: false,
	panelMode: PanelMode.ADD,
	activeLabel: null,
	labelToDelete: null
};

export const useLabelManagementStore = create<LabelManagementState>((set) => {
	// If platformConfigStore is already initialized (e.g. hot reload), populate immediately
	const { isInitialized, coreLabels, additionalLabels } = usePlatformConfigStore.getState();
	const labels = isInitialized ? mapPlatformLabels(coreLabels, additionalLabels) : [];

	// Subscribe to future initialization
	usePlatformConfigStore.subscribe((state) => {
		if (state.isInitialized) {
			set({ labels: mapPlatformLabels(state.coreLabels, state.additionalLabels) });
		}
	});

	return {
		...initialState,
		labels,

		saveLabel: async () => {
			// Implemented in EW-14990 / EW-14991
		},

		deleteLabel: async () => {
			// Implemented in EW-14991
		},

		openAddPanel: () => {
			set({ isPanelOpen: true, panelMode: PanelMode.ADD, activeLabel: null });
		},

		openEditPanel: (label: Label) => {
			set({ isPanelOpen: true, panelMode: PanelMode.EDIT, activeLabel: label });
		},

		closePanel: () => {
			set({ isPanelOpen: false, activeLabel: null });
		},

		requestDelete: (label: Label) => {
			set({ labelToDelete: label });
		},

		cancelDelete: () => {
			set({ labelToDelete: null });
		},

		reset: () => set(initialState)
	};
});
